import React, { useState, useEffect } from 'react'
import useTranslation from 'next-translate/useTranslation'
import useStatusUpdate from 'tennders-transactions/hooks/useStatusUpdate'
import useSocket from 'tennders-common/hooks/useSocket'
import useTransactions from 'tennders-transactions/hooks/useTransactions'
import usePopup from 'tennders-common/hooks/usePopup'
import useBoardView from 'tennders-market/common/hooks/useBoardView'
import GConfirm from 'tennders-market/common/components/popup/GConfirm'
import { useToast } from 'tennders-common/hooks/useToast'
import useSession from 'tennders-auth/hooks/useSession'

const MStatusChange = () => {
  const [comment, setcomment] = useState('')
  const [submitting, setsubmitting] = useState(false)
  const { setRefresh } = useSocket()
  const { popWarning } = usePopup()
  const { t } = useTranslation()
  const { editTransaction } = useTransactions()
  const { listMode } = useBoardView()
  const { toastError } = useToast()
  const { isBroker } = useSession()
  const {
    statusupdate,
    setstatusupdate,
    loadStatusMessage,
    statusMessage,
    statusTitle,
    resetTexts
  } = useStatusUpdate()

  const updateStatus = async () => {
    setsubmitting(true)
    let params = { status: statusupdate.action, comment }
    if (statusupdate.params) {
      params = { ...params, ...statusupdate.params }
    }
    const response = await editTransaction(statusupdate.transaction.id, params)
    setsubmitting(false)
    const error = response?.error || response?.errors?.message
    if (error) {
      toastError(error)
      setstatusupdate(false)
      return
    }
    const users = []
    if (response && Array.isArray(response)) {
      let userName = ''
      response.forEach((x) => {
        if (userName !== x.name) {
          users.push(x.name)
        }
        userName = x.name
      })
    }
    let popMsg
    if (users.length > 1 && isBroker()) {
      popMsg = t('modal:users_informed_multiple', { users: users.join(', ') })
    } else if (users.length > 0 && isBroker()) {
      popMsg = t('modal:users_informed_single', { users })
    } else {
      popMsg = t('modal:related_users_informed')
    }
    popWarning({
      msg: popMsg,
      title: t('modal:updateStatus'),
      onOk: () => {
        setcomment('')
        resetTexts()
        popWarning(false)
        setRefresh('transaction')
        setRefresh('all')
        setstatusupdate(false)
      }
    })
  }

  const onCancel = () => {
    setcomment('')
    resetTexts()
    setstatusupdate(false)
    if (listMode === 'board') {
      setRefresh('fast')
    }
  }

  useEffect(() => {
    if (statusupdate) {
      loadStatusMessage(statusupdate.action)
    }
  }, [statusupdate])

  return (
    <GConfirm
      onOk={updateStatus}
      isOpen={!!statusupdate}
      title={`${t('modal:changeStatusAsk')}`}
      subtitle={statusTitle}
      withInput
      submitting={submitting}
      inputValue={comment}
      inputTitle={t('modal:comment')}
      onInputChange={(val) => setcomment(val)}
      msg={statusMessage}
      onCancel={onCancel}
      close={onCancel}
    />
  )
}

export default MStatusChange
